import { COLUMN_NAMES } from './columnNames';

export const ROWS_OPTIONS = [
  { label: '10 rows', value: 10 },
  { label: '20 rows', value: 20 },
  { label: '50 rows', value: 50 },
  { label: '100 rows', value: 100 },
];

export const COLUMNS_NAMES_AND_WIDTHS = [
  { columnName: COLUMN_NAMES.CHECKBOX, width: 60 },
  { columnName: COLUMN_NAMES.RESOURCE_COST, width: 160 },
  { columnName: COLUMN_NAMES.RESOURCE_NAME, width: 160 },
  { columnName: COLUMN_NAMES.RESOURCE_ID, width: 200 },
  { columnName: COLUMN_NAMES.SERVICE, width: 150 },
  { columnName: COLUMN_NAMES.REGION, width: 100 },
  { columnName: COLUMN_NAMES.LINKED_ACCOUNT, width: 150 },
  { columnName: COLUMN_NAMES.TAGS, width: 150 },
  { columnName: COLUMN_NAMES.GOVERNANCE_TAGS, width: 200 },
  { columnName: COLUMN_NAMES.LAST_UPDATE, width: 120 },
  { columnName: COLUMN_NAMES.GOVERNANCE_TAG_ACTION, width: 150 },
  { columnName: COLUMN_NAMES.TAG_ICON, width: 60 },
];

export const SORTING_COLUMN_EXTENSIONS = [
  { columnName: COLUMN_NAMES.GOVERNANCE_TAGS, sortingEnabled: false },
  { columnName: COLUMN_NAMES.TAGS, sortingEnabled: false },
  { columnName: COLUMN_NAMES.GOVERNANCE_TAG_ACTION, sortingEnabled: false },
  { columnName: COLUMN_NAMES.TAG_ICON, sortingEnabled: false },
];

export const COLUMN_RESIZING_EXTENSIONS = [
  { columnName: COLUMN_NAMES.GOVERNANCE_TAGS, minWidth: 200, maxWidth: 200 },
  { columnName: COLUMN_NAMES.LAST_UPDATE, minWidth: 120, maxWidth: 120 },
  { columnName: COLUMN_NAMES.GOVERNANCE_TAG_ACTION, minWidth: 150, maxWidth: 150 },
  { columnName: COLUMN_NAMES.TAG_ICON, minWidth: 60, maxWidth: 60 },
];

export const FIXED_RIGHT_COLUMNS = [
  COLUMN_NAMES.GOVERNANCE_TAGS,
  COLUMN_NAMES.LAST_UPDATE,
  COLUMN_NAMES.GOVERNANCE_TAG_ACTION,
  COLUMN_NAMES.TAG_ICON,
];

export const FIXED_COLUMNS_FOR_RESIZING = [
  COLUMN_NAMES.GOVERNANCE_TAGS,
  COLUMN_NAMES.LAST_UPDATE,
  COLUMN_NAMES.GOVERNANCE_TAG_ACTION,
  COLUMN_NAMES.TAG_ICON,
];
